{
  "import.inkind.20230223": "Endra kolonnenamn på dato.",
  "warning.30days": "Obs! Endring i Excel-mal i løpet av dei siste 30 dagane.",
  "warning.tips": "Det kan være lurt å laste ned malen på nytt for å ikkje få nokon konflikter."
}
